<template>
  <div id="map" class="block_screen">
    <img id="dummyimage" class="img-center" :src="items[index]" alt="">
    <a @click.prevent="changeScreen(27)" :class="{ 'br-btn26': true, 'flash_btn': index === 4 }" href=""></a>
    <div class="btn_left">
      <a href="" @click.prevent="changeScreen(25)"
         class="btn btn_orange">Zurück</a>
    </div>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  export default {
    data() {
      return {
        index: 0,
        items: [
          'assets/backup_screens/scr28.png',
          'assets/backup_screens/scr29.png',
          'assets/backup_screens/scr29-1.png',
          'assets/backup_screens/scr30.png',
          'assets/backup_screens/scr31.png',
        ],
      };
    },
    mounted() {
      setInterval(this.updateIndex, 1000);
    },

    methods: {
      ...mapMutations({
        changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
      }),
      updateIndex() {
        if(this.index < 4) {
          this.index++;
        }
      },
    },
  };
</script>
<style type="text/css">
  .br-btn26 {
    position: absolute;
    top: 570px;
    left: 110px;
    width: 492px;
    height: 40px;
  }
</style>
